// extracted by mini-css-extract-plugin
export var drawerPaper = "_22-0";
export var itemCard = "_22-1";
export var itemImage = "_22-2";